<template lang="html">
  <div class="phrase alt">
    <span class="word" v-for="(word, index) in words" :key="'w-' + index">
      <span class="first" :key="'f-' + index">{{ word.first }}</span>
      <span class="rest" :key="'w-' + index" v-html="word.rest"></span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    phrase: String
  },
  data() {
    return {
      words: [],
      first: '',
      rest: ''
    }
  },
  watch: {
    phrase(val) {
      if (val) {
        this.$nextTick(() => {
          this.populate()
        })
      }
    }
  },
  mounted() {
    if (this.phrase) {
      this.populate()
    }
  },
  methods: {
    populate() {
      let words = this.phrase.split(' ')
      for (var i = 0; i < words.length; i++) {
        let composed = {
          "first": words[i].slice(0, 1),
          "rest": words[i].slice(1) + '&nbsp;'
        }
        this.words.push(composed)
      }
    }
  }
}
</script>

<style lang="scss">
div.phrase {
    display: inline-block;
    span {
        display: inline-block;
    }
    .first {
        text-transform: capitalize;
        // padding-left: calc(0.25 * var(--lh));
        &:first-of-type {
            // padding-left: 0;
        }
    }
    &.alt {
        .rest {
            transition: transform 0.5s;
            transform: translateY(0%);
        }
        &:hover {
            .rest {
                transform: translateY(-15%);
            }
        }
    }
}
.switcher {
    .active {
        .phrase {
            .rest {
                transform: translateY(-15%) !important;
            }
        }
    }
}
.next,
.prev {
    &:hover {
        .phrase {
            .rest {
                transform: translateY(-15%) !important;
            }
        }
    }
}

.project {
    &:hover {
      .project-title {
          .phrase {
              .rest {
                  transform: translateY(-15%) !important;
              }
          }
      }
    }
}

.projects {
  .project-item {
    &:hover {
      .project-title {
          .phrase {
              .rest {
                  transform: translateY(-15%) !important;
              }
          }
      }
    }
  }
}

.project-images {
  .project-title {
    &:hover {
      .phrase {
          .rest {
              transform: translateY(-15%) !important;
          }
      }
    }
  }
}



tbody {
    a {
        &:hover {
            td {
                .phrase {
                    .rest {
                        transform: translateY(-15%) !important;
                    }
                }
            }
        }
    }
}
</style>
